import axios from "@/plugins/axios";

let url = "/api/console/shop/statistics";

export default {
    getStatistics(data){
        return axios.get(`${url}/${data.code}`).then(result => result.data);
    }
}
